import { Link } from '../components/Link';

export const NotFoundPage = () => (
  <section className="min-h-[70vh] px-6 sm:px-10 md:px-16 py-28 flex items-center">
    <div className="container mx-auto max-w-6xl">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-5">
          <span className="text-[#0D0A00]/35 font-mono text-[13px] tracking-wider">ERROR / 404</span>
          <h1 className="mt-6 text-[#0D0A00] text-[56px] md:text-[88px] font-medium tracking-[-0.035em] leading-[0.98]">
            Pagina niet{' '}
            <span className="font-serif-display italic font-normal text-[#0D0A00]/60">gevonden.</span>
          </h1>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <p className="text-[#0D0A00]/60 text-[17px] leading-[1.65] max-w-[48ch] mb-8">
            Deze pagina bestaat niet (meer). Geen zorgen — je kunt altijd terug naar de start of langskomen bij het veld.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              href="/"
              className="btn-pill"
              style={{ background: '#0D0A00', color: '#fff' }}
            >
              Terug naar home
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <path d="M2 6H10M10 6L6 2M10 6L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
            <Link
              href="/contact"
              className="btn-pill"
              style={{ background: 'transparent', color: '#0D0A00', border: '1px solid rgba(13,10,0,0.18)' }}
            >
              Neem contact op
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);
